function cleanPath(pathname = "/") {
  const withoutQuery = pathname.split("?")[0].split("#")[0];

  if (withoutQuery === "/") {
    return "/";
  }

  return withoutQuery.endsWith("/") ? withoutQuery.slice(0, -1) : withoutQuery;
}

export function parsePath(pathname = "/") {
  const path = cleanPath(pathname);
  try {
    return parseCleanPath(path);
  } catch (error) {
    if (error instanceof URIError) return { name: "not-found", params: {} };
    throw error;
  }
}

function parseCleanPath(path) {

  if (path === "/") {
    return { name: "home", params: {} };
  }

  if (path === "/blog") {
    return { name: "blog", params: {} };
  }

  if (path === "/credits") {
    return { name: "credits", params: {} };
  }

  const blogPostMatch = path.match(/^\/blog\/([^/]+)$/);
  if (blogPostMatch) {
    return {
      name: "blog-post",
      params: {
        slug: decodeURIComponent(blogPostMatch[1]),
      },
    };
  }

  const seasonMatch = path.match(/^\/show\/([^/]+)\/season\/([1-9]\d*)$/);
  if (seasonMatch) {
    return {
      name: "season",
      params: { id: decodeURIComponent(seasonMatch[1]), season: Number(seasonMatch[2]) },
    };
  }

  const episodeMatch = path.match(/^\/show\/([^/]+)\/episode\/([^/]+)$/);
  if (episodeMatch) {
    return {
      name: "episode",
      params: {
        id: decodeURIComponent(episodeMatch[1]),
        episodeId: decodeURIComponent(episodeMatch[2]),
      },
    };
  }

  const showMatch = path.match(/^\/show\/([^/]+)$/);
  if (showMatch) {
    return {
      name: "show",
      params: {
        id: decodeURIComponent(showMatch[1]),
      },
    };
  }

  return { name: "not-found", params: {} };
}

export function buildShowPath(showId) {
  return `/show/${encodeURIComponent(showId)}`;
}

export function buildSeasonPath(showId, season) {
  return `${buildShowPath(showId)}/season/${season}`;
}

export function buildEpisodePath(showId, episodeId) {
  return `/show/${encodeURIComponent(showId)}/episode/${encodeURIComponent(episodeId)}`;
}

export function buildBlogPath(slug) {
  if (!slug) {
    return "/blog";
  }

  return `/blog/${encodeURIComponent(slug)}`;
}
